import React from 'react';
import { Utensils, Clock } from 'lucide-react';
import SEO from './SEO';

const BackgroundPattern = () => (
    <svg viewBox="0 0 1440 800" className="absolute inset-0 w-full h-full object-cover z-0 pointer-events-none" preserveAspectRatio="xMidYMid slice">
        <defs>
            <linearGradient id="warmGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#ea580c" />
                <stop offset="100%" stopColor="#c2410c" />
            </linearGradient>
        </defs>
        <rect width="100%" height="100%" fill="url(#warmGrad)" />
    </svg>
);

export default function PageBuchta() {
    return (
        <div className="relative w-full overflow-hidden">
            <SEO
                title="Najlepšia Vodácka Buchta | Sprievodná súťaž"
                description="Tradičná súťaž v pečení a varení počas maratónu. Ochutnajte tie najlepšie dobroty v cieľovom areáli pretekov."
                keywords="najlepšia buchta, vodácka kuchyňa, súťaž v pečení, sladké, slané"
            />
            <div className="absolute inset-0 z-0">
                <BackgroundPattern />
            </div>
            <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20">
                <h2 className="text-2xl md:text-5xl font-black uppercase tracking-widest flex items-center gap-4 mb-8" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    <Utensils className="w-8 h-8 md:w-12 md:h-12 text-white" />
                    <span className="text-white drop-shadow-md">Sprievodný program</span>
                </h2>

                <div className="bg-white/95 backdrop-blur-md rounded-2xl md:rounded-3xl p-4 sm:p-8 lg:p-12 shadow-2xl border-4 border-orange-500 flex flex-col md:flex-row-reverse gap-8 md:gap-12 items-center overflow-hidden">
                    <div className="w-full md:w-1/2 flex justify-center">
                        <img
                            src="/kucharka_buchta.png"
                            alt="Kuchárka Maskot"
                            className="w-full max-w-[450px] h-auto object-contain transform rotate-3 hover:rotate-0 transition-transform duration-500 drop-shadow-2xl"
                        />
                    </div>

                    <div className="flex-grow w-full text-center md:text-left md:w-1/2 min-w-0">
                        <div className="bg-orange-500 text-white px-2.5 sm:px-4 py-1.5 rounded-sm shadow-md inline-block transform -skew-x-12 mb-6 max-w-[90%]">
                            <span className="font-black uppercase tracking-widest block transform skew-x-12 text-[10px] sm:text-sm whitespace-normal" style={{ fontFamily: 'Montserrat, sans-serif' }}>Súťaž v pečení</span>
                        </div>

                        <h1 className="text-orange-600 font-black leading-[0.95] uppercase tracking-wider text-[2.75rem] sm:text-5xl lg:text-7xl mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                            Najlepšia<br />
                            <span className="text-yellow-500 drop-shadow-sm">Vodácka</span><br />
                            Buchta
                        </h1>

                        <p className="text-gray-700 font-bold text-base md:text-xl mb-8 max-w-2xl leading-relaxed">
                            Od jubilejného 10. ročníka bude táto súťaž neodmysliteľnou súčasťou maratónu a odteraz si na nej budeme pochutnávať každý rok!
                            Druh koláča, či sladký, slaný, cheesecake, pagáče, bábovka, alebo nejaké kysnuté, je to na vás – stačí si vybrať a doniesť.
                        </p>

                        <div className="mb-10 text-left">
                            <h3 className="text-xl font-black uppercase text-[#1E3A8A] mb-6 flex items-center gap-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                                <div className="w-8 h-1 bg-[#FACC15]"></div>
                                Ako to bude prebiehať?
                            </h3>

                            <div className="space-y-6">
                                <div className="flex gap-5">
                                    <div className="flex flex-col items-center">
                                        <div className="bg-orange-500 text-white p-3 rounded-full shadow-lg z-10">
                                            <Clock className="w-6 h-6" />
                                        </div>
                                        <div className="w-0.5 h-full bg-orange-200 mt-1"></div>
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="text-sm font-black text-orange-600 uppercase tracking-tighter">do 13:00</div>
                                        <h4 className="text-base sm:text-lg font-black text-gray-800 uppercase leading-snug" style={{ fontFamily: 'Montserrat, sans-serif' }}>Odovzdanie dobrôt</h4>
                                        <p className="text-gray-600 text-[13px] sm:text-sm mt-1 max-w-lg leading-snug">
                                            Prinest aspoň 1 plech napečených vzoriek organizátorom do areálu táboriska (Nová Dedinka).
                                            Registrácia vopred nie je potrebná, stačí len prísť a priniesť svoju dobrotu.
                                        </p>
                                    </div>
                                </div>

                                <div className="flex gap-5">
                                    <div className="flex flex-col items-center">
                                        <div className="bg-yellow-500 text-[#1E3A8A] p-3 rounded-full shadow-lg z-10">
                                            <Utensils className="w-6 h-6" />
                                        </div>
                                        <div className="w-0.5 h-full bg-yellow-200 mt-1"></div>
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="text-sm font-black text-yellow-600 uppercase tracking-tighter">od 14:00</div>
                                        <h4 className="text-base sm:text-lg font-black text-gray-800 uppercase leading-snug" style={{ fontFamily: 'Montserrat, sans-serif' }}>Veľká ochutnávka</h4>
                                        <p className="text-gray-600 text-[13px] sm:text-sm mt-1 max-w-lg leading-snug">
                                            Vaše dobroty budú vystavené v samostatnom stánku, kde môžu súťažiaci, sprievod alebo fanúšikovia ochutnávať a hodnotiť.
                                        </p>
                                    </div>
                                </div>

                                <div className="flex gap-5">
                                    <div className="flex flex-col items-center">
                                        <div className="bg-[#1E3A8A] text-[#FACC15] p-3 rounded-full shadow-lg z-10">
                                            <Utensils className="w-6 h-6" />
                                        </div>
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <h4 className="text-base sm:text-lg font-black text-gray-800 uppercase leading-snug" style={{ fontFamily: 'Montserrat, sans-serif' }}>Vyhlásenie víťaza</h4>
                                        <p className="text-gray-600 text-[13px] sm:text-sm mt-1 max-w-lg font-bold leading-snug">
                                            Pekárka alebo pekár s najvyšším počtom hlasov získa oficiálny a hrdý titul pre tento ročník maratónu!
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}
